AGADash.Filter.Predefined = (function () {

    var setFilterKey = function (innerTarget, key) {
        var me = $(innerTarget).closest(".dash-filter");
        if (key && key.length > 0) {
            var value = "predefined|" + key + "|";
            $(me).attr("filter-user-key", value);
        } else {
            $(me).removeAttr("filter-user-key");
        }
    };

    var setValueAndUpdate = function (target, value, schedule) {
        setFilterKey(target, value);
        if (schedule) {
            AGADash.Panel.scheduleUpdate(target);
        } else {
            AGADash.Panel.updatePanel(target);
        }
    };

    var changeHandler = function (e) {
        AGADash.Panel.cancelSchedule();

        var v = $(e.target).val();
        var handles = $.isArray(v) ? v.join(",") : v;

        setValueAndUpdate(e.target, handles);
    };

    var initPredefinedFilter = function (target, filterInfo) {
        var config = {
            allowClear: true
        };
        if (filterInfo.MaxLength && filterInfo.MaxLength > 1) {
            config.maximumSelectionSize = filterInfo.MaxLength;
            config.maximumSelectionLength = filterInfo.MaxLength; // compatibilidade com futuro
        }
        var sel = $(target).select2(config);

        // Se for um registro, deve inicializar limpo
        if (filterInfo.MaxLength === 1 && filterInfo.ItemPadrao) {
            $(target).val(filterInfo.ItemPadrao);
            setValueAndUpdate(target, filterInfo.ItemPadrao, true);
        }
        sel.on("change", changeHandler);
    };

    function renderFilterPredefinedAsCombo(placeHolder, filterInfo) {
        var sel = document.createElement("select");
        $(sel).addClass("form-control input-sm dash-filter-predefined");

        if (filterInfo.MaxLength > 1) {
            $(sel).attr("multiple", "multiple");
        }

        if (filterInfo.Predefinidos) {
            $(sel).append(
                filterInfo.Predefinidos.map(function (item) {
                    var opt = document.createElement("option");
                    var parts = item.split("|");
                    if (parts.length === 2) {
                        $(opt).attr("value", parts[0]).text(parts[1]);
                    }
                    return opt;
                }));
        }
        $(sel).appendTo(placeHolder);
        initPredefinedFilter(sel, filterInfo);
    }

    function renderFilterPredefinedAsButtonSingle(placeHolder, filterInfo) {
        var mustUpdate = false;
        var name = AGADash.getUniqueId();
        var div = document.createElement("div");
        $(div).addClass("btn-group btn-group-devided")
            .attr({ "data-toggle": "buttons" })
            .appendTo(placeHolder);

        for (var i = 0; i < filterInfo.Predefinidos.length; i++) {
            var parts = filterInfo.Predefinidos[i].split("|");
            if (parts.length === 2) {
                var lab = document.createElement("label");
                $(lab).addClass("btn blue btn-transparent btn-outline btn-circle btn-sm predefined-item")
                    .text(parts[1])
                    .appendTo(div);

                var input = document.createElement("input");
                $(input)
                    .attr({ "type": "radio", "name": name, "value": parts[0] })
                    .addClass("toggle")
                    .prependTo(lab);

                if (filterInfo.ItemPadrao && filterInfo.ItemPadrao === parts[0]) {
                    $(lab).addClass("active");
                    mustUpdate = true;
                }
            }
        }

        $(div).on("click", ".predefined-item", function (e) {
            var target = $(e.target).closest("label").find("input").first();
            changeHandler({ "target": target });
        });

        if (mustUpdate) {
            setValueAndUpdate(placeHolder, filterInfo.ItemPadrao, true);
        }
    }

    var renderFilter = function (placeHolder, filterInfo) {

        if (filterInfo.MaxLength === 1 && filterInfo.Predefinidos
            && filterInfo.Predefinidos.length <= 5)
            renderFilterPredefinedAsButtonSingle(placeHolder, filterInfo);
        else
            renderFilterPredefinedAsCombo(placeHolder, filterInfo);

    };
    return {
        renderFilter: renderFilter
    };


})();

AGADash.Filter.setFilterClass("predefinido", AGADash.Filter.Predefined);
